import { useState, useEffect } from "react";

import {
	scroll,
	API_URL,
	translate,
	fmtCurrency,
	createMarkup,
} from "../../utils";
import useFetch from "../../utils/useFetch";

import Alert from "../../components/Alert";

import ReceiptTableSummary from "./ReceiptTableSummary";
import ReceiptTableOrder from "./ReceiptTableOrder";

const Receipt = ({ id, lang }) => {
	const [url, setUrl] = useState(null);
	const [details, setDetails] = useState({});

	const { loading, data } = useFetch(url);

	useEffect(() => {
		scroll();
		const newUrl = new URL(`${API_URL}/jgsReceiptInit`);
		const params = {
			id,
		};
		newUrl.search = new URLSearchParams(params);
		setUrl(newUrl);
	}, []);

	useEffect(() => {
		if (data && data.resp === 1) {
			setDetails({
				...data,
			});
		}
	}, [data]);

	return (
		<>
			{loading ? (
				<Alert
					data={{
						type: "working",
						text: "",
					}}
				/>
			) : (
				<>
					<div className="match-play-container">
						<div>
							<div
								className="receipt"
								style={{
									fontSize: "0.95rem",
									lineHeight: "22px",
								}}
							>
								<i className="fa fa-check-circle fa-3x" />
								<div className="subhead">
									{translate(
										lang,
										`¡Gracias por inscribirte a Los Cabos Junior Golf Series! Recibirás más información sobre tu participación, incluso tee times, una vez cerrado el proceso de inscripción.`,
										`¡Gracias por inscribirte a Los Cabos Junior Golf Series! Recibirás más información sobre tu participación, incluso tee times, una vez cerrado el proceso de inscripción.`,
									)}
								</div>
							</div>
							<div className="spacer-15"> </div>
							<ul>
								<li>
									{translate(
										lang,
										`Al llegar el día del evento, favor de pasar por la mesa de registro para confirmar tu asistencia y recibir cualquier información adicional.`,
										`Al llegar el día del evento, favor de pasar por la mesa de registro para confirmar tu asistencia y recibir cualquier información adicional.`,
									)}
								</li>
								<li>
									{translate(
										lang,
										`Cada participante será asignado un carrito de golf.  Y cada participante deberá ser acompañado por un adulto quien manejará el carrito del jugador y actuará como su caddie.   Solo se permiten dos personas (jugador(a) y caddie) por carrito.  Carritos adicionales estarán en renta para espectadores, sujeto a disponibilidad.  El costo corre por el espectador.`,
										`Cada participante será asignado un carrito de golf.  Y cada participante deberá ser acompañado por un adulto quien manejará el carrito del jugador y actuará como su caddie.   Solo se permiten dos personas (jugador(a) y caddie) por carrito.  Carritos adicionales estarán en renta para espectadores, sujeto a disponibilidad.  El costo corre por el espectador.`,
									)}
								</li>
								<li>
									{translate(
										lang,
										`Al terminar la ronda, el jugador deberá acercarse a la mesa de scoring para entregar y firmar su tarjeta de puntuación.`,
										`Al terminar la ronda, el jugador deberá acercarse a la mesa de scoring para entregar y firmar su tarjeta de puntuación.`,
									)}
								</li>
								<li>
									{translate(
										lang,
										`Una breve ceremonia de premiación se llevará a cabo una vez concluidas todas las rondas de golf, por lo que les pedimos permanecer hasta el final del evento.`,
										`Una breve ceremonia de premiación se llevará a cabo una vez concluidas todas las rondas de golf, por lo que les pedimos permanecer hasta el final del evento.`,
									)}
								</li>
								<li
									dangerouslySetInnerHTML={createMarkup(
										translate(
											lang,
											`Para cualquier inquietud por favor contáctanos a esta dirección <a href="mailto:cramos@wwtchampionship.com">cramos@wwtchampionship.com</a>.`,
											`Para cualquier inquietud por favor contáctanos a esta dirección <a href="mailto:cramos@wwtchampionship.com">cramos@wwtchampionship.com</a>.`,
										),
									)}
								/>
							</ul>

							<p
								style={{
									fontSize: "0.95rem",
									lineHeight: "22px",
								}}
								dangerouslySetInnerHTML={createMarkup(
									translate(
										lang,
										`Si deseas hacer WD, es necesario enviar correo a <a href="mailto:cramos@wwtchampionship.com">cramos@wwtchampionship.com</a>.`,
										`Si deseas hacer WD, es necesario enviar correo a <a href="mailto:cramos@wwtchampionship.com">cramos@wwtchampionship.com</a>.`,
									),
								)}
							/>

							<div className="spacer-15"> </div>

							<p
								style={{
									fontSize: "0.95rem",
									lineHeight: "22px",
								}}
								dangerouslySetInnerHTML={createMarkup(
									translate(
										lang,
										`Todas las ventas son finales. En caso de hacer WD antes de el lunes antes de cada torneo, se te cobrará un cargo de cancelación de $400 MXN. En caso de hacer WD después de la fecha límite, no hay reembolso. Al ingresar la información del pago, aceptaste las condiciones de compra.`,
										`Todas las ventas son finales. En caso de hacer WD antes de el lunes antes de cada torneo, se te cobrará un cargo de cancelación de $400 MXN. En caso de hacer WD después de la fecha límite, no hay reembolso. Al ingresar la información del pago, aceptaste las condiciones de compra.`,
									),
								)}
							/>
						</div>
					</div>

					<div className="spacer-5"> </div>

					<ReceiptTableSummary
						translate={translate}
						lang={lang}
						date={details.date}
						id={details.id}
						name={details.name}
					/>

					<ReceiptTableOrder
						translate={translate}
						lang={lang}
						items={details.items}
						payment={details.payment}
					/>
				</>
			)}
		</>
	);
};

export default Receipt;
